module.exports = __webpack_public_path__ + "static/media/logo192.3ee98ce1.png";